import {FC} from 'react';
import {useLocation, useParams} from 'react-router-dom';
import {useRecoilValueLoadable} from 'recoil';
import {reportQueryFamily} from '../../store/reports/selectors';
import {Report} from '../../components/Reports';
import Fallback from '../../ui/fallback/Fallback';

const ReportPage: FC = () => {
  const {id} = useParams();
  const {contents, state} = useRecoilValueLoadable(reportQueryFamily(String(id)));
  const location = useLocation();

  return (
    <div>{state === 'loading' && !location.state ? <Fallback /> : <Report report={location.state || contents} />}</div>
  );
};

export default ReportPage;
